// LICENSE : MIT
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Internal implementation
 * @private
 */
var DispatcherPayloadMetaImpl = /** @class */ (function () {
    function DispatcherPayloadMetaImpl(args) {
        this.useCase = args.useCase || null;
        this.parentUseCase = args.parentUseCase || null;
        this.timeStamp = Date.now();
        this.isTrusted = args.isTrusted;
        this.isUseCaseFinished = args.isUseCaseFinished !== undefined ? args.isUseCaseFinished : false;
        this.transaction = args.transaction;
    }
    return DispatcherPayloadMetaImpl;
}());
exports.DispatcherPayloadMetaImpl = DispatcherPayloadMetaImpl;
//# sourceMappingURL=DispatcherPayloadMeta.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/DispatcherPayloadMeta.js
// module id = 32
// module chunks = 0